export function footerInit() {
  document.addEventListener("DOMContentLoaded", function () {
    // Back to top logic
    const backToTopButton = document.querySelector(
      ".site-footer-top-back-to-top"
    );

    backToTopButton.addEventListener("click", (e) => {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  });
}
